import axios from "axios";
import { getStagesUrls } from "./endpoints/stages";


export async function getAllStagesNames(request = {},domain) {
  const payload = {
    ...request,
  };
  const url = getStagesUrls(domain);
  return await axios.post(
  
    url.getAllStages,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  );
}

export async function updateStatus(request = {},domain) {
  const payload = {
    ...request,
  };
  const url = getStagesUrls(domain);
  return await axios.post(
  
    url.nextStatus,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  );
}

